import React from "react";

import { faUsers } from "@awesome.me/kit-4c83d50d0d/icons/kit/custom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { AppContext } from "~/common";
import type { AttendeeAttrs } from "~/common/Attendees";
import { MeetingInfoModalAttendeesList } from "~/nav/panels/Meetings/MeetingInfoModal";

import type { RowProps } from "./index";

import styles from "./ViewEvent.module.css";

export default function AttendeesRow({ eventData }: RowProps) {
	const { user } = React.useContext(AppContext);

	if (!eventData?.attendees || eventData.attendees.length === 0) {
		return null;
	}

	let attendees = eventData.attendees.slice();
	if (!attendees || attendees.length === 0) return null;

	if (user) {
		const currentUserAttendeeIndex = attendees.findIndex(att => att?.email === user.email);
		if (currentUserAttendeeIndex >= 0 && attendees[currentUserAttendeeIndex]) {
			// @ts-ignore
			attendees[currentUserAttendeeIndex] = {
				...attendees[currentUserAttendeeIndex],
				responseStatus: eventData.userResponseStatus,
			};
		}
	}

	return (
		<div className={styles.infoRow}>
			<div className={cx(styles.infoRow__icon, styles.centeredOnFirstLine)}>
				<FontAwesomeIcon fixedWidth icon={faUsers} />
			</div>
			<div className={styles.attendeesWrapper}>
				<MeetingInfoModalAttendeesList attendees={attendees as AttendeeAttrs[]} eventId={eventData.id} />
			</div>
		</div>
	);
}
